import { JSX } from 'react'
import { Quote } from '~/config/quotes'

type QuoteProps = {
  quote: Quote
  hideCta?: boolean
  alignQuote?: string
  partnerText?: JSX.Element
}

export const QuoteBlockv2 = ({
  quote,
  alignQuote,
  partnerText,
}: QuoteProps) => {
  return (
    <div className={`quote-image${alignQuote === 'left' ? ' -left' : ''}`}>
      <div className="quote">
        <blockquote>
          <svg
            width="27"
            height="25"
            viewBox="0 0 27 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.0992845 24.0107V12.2661C0.0992845 4.98002 3.38888 1.22825 9.96806 1.01076L11.3546 0.929199V6.55685H10.0496C7.71156 6.77434 6.54253 8.51429 6.54253 11.7767V13.0817H11.3546V24.0107H0.0992845ZM26.117 6.55685H24.812C22.4739 6.77434 21.3049 8.51429 21.3049 11.7767V13.0817H26.117V24.0107H14.9432V12.2661C14.9432 5.03439 18.2056 1.28263 24.7304 1.01076L26.117 0.929199V6.55685Z"
              fill="hsl(342deg 100% 67%)"
            />
          </svg>
          <div className="quote-content">
            {quote.quote}
            <cite>- {quote.cite} </cite>
          </div>
        </blockquote>
      </div>
      <div className="partner-logo">
        <img src={quote.logo} alt="" />
        {partnerText && <div className="partner-text">{partnerText}</div>}
      </div>
    </div>
  )
}
